import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { LanguageProvider } from './i18n/LanguageContext'
import Page from './Page'

// Each language is a real, separate, indexable URL ("/", "/en", "/bg", "/tr")
// rather than a client-side toggle – see src/i18n/LanguageContext.jsx.
function App() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <LanguageProvider>
            <Page />
          </LanguageProvider>
        }
      />
      <Route
        path="/en/*"
        element={
          <LanguageProvider>
            <Page />
          </LanguageProvider>
        }
      />
      <Route
        path="/bg/*"
        element={
          <LanguageProvider>
            <Page />
          </LanguageProvider>
        }
      />
      <Route
        path="/tr/*"
        element={
          <LanguageProvider>
            <Page />
          </LanguageProvider>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export default App
